import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
// import formatISO from 'date-fns/formatISO'

import { archivedSoldDaysFormatter } from 'Utils/listingUtils'
import SvgIcon from 'Components/SvgIcon'
import { _Banner } from './styles'


export const bannerKeys = {
  1: 'Deal fell through',
  2: 'Expired',
  3: 'Extended',
  4: 'Leased',
  5: 'Leased conditional',
  6: 'Price change',
  7: 'Sold',
  8: 'Sold conditional',
  9: 'Suspended',
  10: 'Terminated',
  11: 'Exclusive',
  12: 'VIP access',
  13: 'Sold out',
  14: 'Active Under Contract',
  15: 'Pending',
  16: 'Closed',
}

class ListingBanner extends PureComponent {
  render() {
    const {
      bannerId, offer, status, featured, listedDays,
      isArchived, endDateUnix,
      forListView, className, userIsAuthentificated,
    } = this.props
    let publicStatus = status === 'Sold' ? (offer === 'Rent' ? 'Leased' : 'Sold') : status
    let bannerCopy = publicStatus

    if(!isArchived && status === 'Active') {
      if(featured) {
        publicStatus = 'Featured'
      } else if(listedDays === 0) {
        publicStatus = 'Just listed'
      } else {
        publicStatus = ''
      }

      if(forListView) {
        const marketOrSiteDays = userIsAuthentificated ? 'market' : 'site'
        bannerCopy = listedDays + ` days on ${marketOrSiteDays}`
      } else {
        bannerCopy = bannerId ? bannerKeys[bannerId] : publicStatus
      }
    } else if(endDateUnix) {
      bannerCopy += ' ' + archivedSoldDaysFormatter(endDateUnix)
    }

    if(!bannerCopy) return ''
    return (
      <_Banner
        featured={featured}
        listViewStyle={forListView}
        className={className}
      >
        {!isArchived && status === 'Active' && featured && !forListView
          ? <SvgIcon name="#icon-star" width={16} height={16} /> : null}
        {bannerCopy}
      </_Banner>
    )
  }
}

ListingBanner.propTypes = {
  isArchived: PropTypes.bool,
  bannerId: PropTypes.number,
  offer: PropTypes.string,
  status: PropTypes.string,
  featured: PropTypes.bool,
  listedDays: PropTypes.number,
  endDateUnix: PropTypes.number,
  forListView: PropTypes.bool,
  className: PropTypes.string,
  userIsAuthentificated: PropTypes.bool,
}

export default ListingBanner
